import React from "react";

const SpineLabel = ({ color = "#FFFFFF" }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Vertebra blocks along a central axis */}
    <rect x="8" y="1" width="6" height="4" rx="1" fill={color} opacity="0.9" />
    <rect x="8" y="6.5" width="6" height="4" rx="1" fill={color} opacity="0.9" />
    <rect x="8" y="12" width="6" height="4" rx="1" fill={color} opacity="0.9" />
    <rect x="8" y="17.5" width="6" height="3" rx="1" fill={color} opacity="0.9" />
    {/* Central canal line */}
    <line x1="11" y1="1" x2="11" y2="21" stroke={color} strokeWidth="1" opacity="0.4" />
    {/* Label tick marks on the left */}
    <line x1="2" y1="3" x2="8" y2="3" stroke={color} strokeWidth="1.2" />
    <line x1="2" y1="8.5" x2="8" y2="8.5" stroke={color} strokeWidth="1.2" />
    <line x1="2" y1="14" x2="8" y2="14" stroke={color} strokeWidth="1.2" />
    <line x1="2" y1="19" x2="8" y2="19" stroke={color} strokeWidth="1.2" />
    {/* Dot indicators */}
    <circle cx="2" cy="3" r="1.2" fill={color} />
    <circle cx="2" cy="8.5" r="1.2" fill={color} />
    <circle cx="2" cy="14" r="1.2" fill={color} />
    <circle cx="2" cy="19" r="1.2" fill={color} />
  </svg>
);

export default SpineLabel;
